(() => {
  if(window.AuziCartDevicePhotos)return;
  const assetUrl=document.currentScript?.dataset?.catalogueUrl||'';
  const stylesUrl=document.currentScript?.dataset?.specificCatalogueUrl||'';
  const assetBase=assetUrl.slice(0,assetUrl.lastIndexOf('/')+1);
  let cataloguePromise=null, stylesPromise=null, lastTrigger=null;
  const normalized=value=>String(value||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'');
  const isValidImageURL = input => {
    try{const url=new URL(input,location.href);return ['https:','http:'].includes(url.protocol)?url.href:null}catch{return null}
  };
  const catalog=()=>{
    if(!cataloguePromise&&assetUrl) cataloguePromise=fetch(assetUrl).then(r=>{if(!r.ok)throw new Error('Catalogue unavailable');return r.json()}).then(j=>Array.isArray(j.devices)?j.devices:[]).catch(()=>[]);
    return cataloguePromise||Promise.resolve([]);
  };
  const styles=()=>{
    if(!stylesPromise && stylesUrl) stylesPromise=fetch(stylesUrl).then(r=>{
      if(!r.ok) throw new Error('Specific models unavailable');
      return r.json();
    }).catch(()=>({images:{}}));
    return stylesPromise||Promise.resolve({images:{}});
  };
  async function hydrateSpecific(root=document){
    const buttons=Array.from(root.querySelectorAll('[data-auzi-device-photo-open][data-auzi-photo-specific]'))
      .filter(button=>button.dataset.auziPhotoUpload!=='true');
    if(!buttons.length)return;
    const data=await styles();
    const photos=data.images||{};
    for(const button of buttons){
      if(!button.isConnected || button.dataset.auziPhotoUpload==='true')continue;
      const brand=button.dataset.auziPhotoBrand||'';
      const model=button.dataset.auziPhotoModel||'';
      const exact=button.dataset.auziPhotoSpecific||'';
      const name=photos[brand]?.[model]?.[exact];
      if(!name || !/^[a-zA-Z0-9._-]+\.(png|jpg|jpeg|webp)$/i.test(name))continue;
      const src=isValidImageURL(new URL(name,assetBase).href);
      if(!src||button.dataset.auziPhotoSrc===src)continue;
      const image=button.querySelector('img');
      if(!image)continue;
      image.onerror=()=>{
        button.hidden=true;button.disabled=true;
        button.closest('[data-auzi-device-photo-row]')?.setAttribute('hidden','');
      };
      image.onload=()=>{
        button.hidden=false;button.disabled=false;
        button.classList.remove('auzi-cart-photo--pending');
        button.closest('[data-auzi-device-photo-row]')?.removeAttribute('hidden');
      };
      button.dataset.auziPhotoSrc=src;
      image.src=src;
    }
  }
  async function hydrate(root=document){
    await hydrateSpecific(root);
    const targets=Array.from(root.querySelectorAll('.auzi-cart-photo--pending[data-auzi-photo-confirmed="true"]'));
    if(!targets.length)return;
    const list=await catalog();
    for(const button of targets){
      if(!button.isConnected||button.dataset.auziPhotoSrc)continue;
      const brand=normalized(button.dataset.auziPhotoBrand);
      const model=normalized(button.dataset.auziPhotoModel);
      if(!brand||!model||model===normalized('To be provided after order'))continue;
      // Require one *unambiguous exact* official model match, never a fuzzy guess.
      const matches=list.filter(d=>
        normalized(d.brand)===brand&&d.image&&(
          normalized(d.model)===model||
          (d.aliases||[]).some(alias=>normalized(alias)===model)
        )
      );
      const unique=[...new Set(matches.map(d=>d.image))];
      if(unique.length!==1||!unique[0])continue;
      const safe=isValidImageURL(new URL(unique[0],assetBase).href);if(!safe)continue;
      button.dataset.auziPhotoSrc=safe;
      const img=button.querySelector('img');if(!img)continue;
      img.onerror=()=>{button.hidden=true;button.disabled=true;button.closest('[data-auzi-device-photo-row]')?.setAttribute('hidden','')};
      img.onload=()=>{
        button.hidden=false;button.disabled=false;button.classList.remove('auzi-cart-photo--pending');
        button.closest('[data-auzi-device-photo-row]')?.removeAttribute('hidden');
      };
      img.src=safe;
    }
  }
  function getDialog(){
    let d=document.getElementById('auzi-cart-device-dialog');
    if(d)return d;
    d=document.createElement('dialog');d.className='auzi-photo-dialog';d.id='auzi-cart-device-dialog';
    const panel=document.createElement('div');panel.className='auzi-photo-dialog__panel';
    const close=document.createElement('button');close.type='button';close.className='auzi-photo-dialog__close';const closeLabels={en:'Close',fr:'Fermer',de:'Schließen',es:'Cerrar',it:'Chiudi',nl:'Sluiten','pt-BR':'Fechar',ja:'閉じる',ko:'닫기',ar:'إغلاق',tr:'Kapat'};const lang=document.documentElement.lang||'en';close.setAttribute('aria-label',closeLabels[lang]||closeLabels[lang.split('-')[0]]||closeLabels.en);close.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m5 5 14 14M19 5 5 19"/></svg>';
    close.addEventListener('click',()=>d.close());
    const img=document.createElement('img');img.className='auzi-photo-dialog__image';img.alt='';
    const title=document.createElement('p');title.id='auzi-photo-dialog-label';title.className='auzi-photo-dialog__label';
    panel.append(close,img,title);d.append(panel);
    d.setAttribute('aria-labelledby',title.id);
    d.addEventListener('click',event=>{if(event.target===d)d.close()});
    d.addEventListener('close',()=>{img.removeAttribute('src');const t=lastTrigger;lastTrigger=null;if(t?.isConnected)t.focus({preventScroll:true})});
    document.body.append(d);return d;
  }
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-auzi-device-photo-open]');
    if(!button||button.disabled)return;
    const src=isValidImageURL(button.dataset.auziPhotoSrc);if(!src)return;
    event.preventDefault();const d=getDialog();const img=d.querySelector('.auzi-photo-dialog__image');
    const label=d.querySelector('.auzi-photo-dialog__label');
    const brand=(button.dataset.auziPhotoBrand||'').trim();
    const family=(button.dataset.auziPhotoModel||'').trim();
    const specific=(button.dataset.auziPhotoSpecific||'').trim();
    const base=[brand,family].filter(Boolean).join(' ');
    const hasSpecific=specific && !/^(?:not sure|unknown|other|to be verified|to be provided|specific device not listed)/i.test(specific)
      && specific.toLowerCase()!==family.toLowerCase()
      && specific.toLowerCase()!==base.toLowerCase();
    // Keep the exact physical style without repeating its family/brand name.
    const specificLower=specific.toLowerCase();
    const baseLower=base.toLowerCase();
    const familyLower=family.toLowerCase();
    const brandLower=brand.toLowerCase();
    const preciseName=hasSpecific
      ? (base && specificLower.startsWith(baseLower+' ') ? specific
        : brand && specificLower.startsWith(brandLower+' ') ? specific
        : family && (specificLower===familyLower || specificLower.startsWith(familyLower+' ')) ? [brand,specific].filter(Boolean).join(' ')
        : [base,specific].filter(Boolean).join(' — '))
      : base;
    const name=preciseName || button.dataset.auziPhotoAlt || 'Device photo';
    img.src=src;img.alt=name;label.textContent=name;
    lastTrigger=button;
    if(!d.open)d.showModal();d.querySelector('.auzi-photo-dialog__close').focus();
  });
  document.addEventListener('DOMContentLoaded',()=>hydrate());
  document.addEventListener('auzi:cart-rendered',event=>hydrate(event.target));
  document.addEventListener('shopify:section:load',event=>hydrate(event.target));
  if(document.readyState!=='loading')hydrate();
  // Cart drawers replace their contents asynchronously. Hydrate newly inserted lines.
  let scheduled=false;
  const observer=new MutationObserver(records=>{
    if(scheduled||!records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('.auzi-cart-photo--pending, [data-auzi-photo-specific]')||n.querySelector?.('.auzi-cart-photo--pending, [data-auzi-photo-specific]')))))return;
    scheduled=true;requestAnimationFrame(()=>{scheduled=false;hydrate()});
  });
  if(document.body)observer.observe(document.body,{childList:true,subtree:true});
  window.AuziCartDevicePhotos={hydrate};
})();